import type { app } from "@microsoft/teams-js";
import { safeLocalStorage } from "client_legacy/ndaw/safeStorage";

let teamsInitPromise: Promise<void>;

export async function isEmbeddedInMsTeamsAppCheck(): Promise<boolean> {
	if (!didPassTeamsEntryPoint()) {
		return false;
	}

	try {
		const {
			app,
			HostName,
			HostClientType
		} = await import("@microsoft/teams-js");

		if (!teamsInitPromise) {
			teamsInitPromise = app.initialize();
		}

		await teamsInitPromise;

		const context: app.Context = await app.getContext();

		const {
			name,
			clientType
		} = context.app.host;

		const isTeams: boolean = [
			HostName.teams,
			HostName.teamsModern
		]
			.includes(name);

		const isWebVersion: boolean = clientType === HostClientType.web;

		return isTeams
			&& !isWebVersion;
	} catch (e) {
		return false;
	}
}

const didPassTeamsEntryPointStorageKey = "did-pass-teams-entrypoint";

function didPassTeamsEntryPoint(): boolean {
	return safeLocalStorage.getItem(didPassTeamsEntryPointStorageKey) === true;
}

export function checkInAtMsTeamsEntryPoint(): void {
	safeLocalStorage.setItem(didPassTeamsEntryPointStorageKey, true);
}